module.exports = "https://health.dajiuxing.com.cn/img/assets/img/integral_img1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2Fimg%2Fintegral_img1.png
// module id = ZKAB
// module chunks = 93